import { FormList } from './../../core/models/form-list.model';
import { Component, OnInit } from '@angular/core';
import { FormService } from "../../core/services/form.service";
import { CommonService } from "../../core/services/common.service";
import { Pagination } from "../../core/models/pagination.model";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { URLSearchParams } from "@angular/http";
import { FormGroup, FormBuilder } from '@angular/forms';
import { ExportExcelComponent } from '../../common/export-excel/export-excel.component';

declare const swal: any;

@Component({
  selector: 'app-form-invitees-list',
  templateUrl: './form-invitees-list.component.html',
  styleUrls: ['./form-invitees-list.component.css']
})
export class FormInviteesListComponent extends ExportExcelComponent implements OnInit {
  ids: number[] = [];
  pagination: Pagination = new Pagination;
  fetchingInProgress = false;

  maxFollowUpallowed: number = 2;
  forms: FormList[] = [];

  filterParams: URLSearchParams = new URLSearchParams();
  filterFormGroup: FormGroup;

  constructor(
    private formService: FormService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.route.queryParams.subscribe(params => {
      Object.keys(params).forEach(key => {
        if (params[key] !== '') {
          this.filterParams.set(key, params[key]);
        }
      });
      this.setDefault();
      this.filterResults();
    });

    this.getForms();
  }

  initForm(): void {
    this.filterFormGroup = this.fb.group({
      // email_status: '',
      email_id: 'all',
      is_filled: 'all',
      created_after: 'all',
      created_before: 'all',
      form_id: [''],
      is_active: [''],
      page: '1',
    });
  }

  getForms(): void {

    this.formService.getFormsList().subscribe(
      response => {
        this.forms = response;
      }
    );
  }

  filterResults() {
    this.formService.getAllInvitees(this.filterParams).subscribe(
      pagination => {
        this.pagination = pagination;
      },
      error => {
        this.commonService.notifications.error('Some Error Occurred');
      }
    );
  }

  // Load Next Page when using Pagination
  showPage(page: string) {

    // Set our navigation extras object
    // that contains our global query params and fragment
    const navigationExtras: NavigationExtras = {
      queryParams: {
        page: page
      },
      queryParamsHandling: 'merge'
    };

    // Get the current path
    const currentUrlPath = this.router.url.split('?')[0];

    this.router.navigate([currentUrlPath], navigationExtras);
  }

  filterQueriedResults(): void {

    this.filterParams = new URLSearchParams();

    // Set our navigation extras object
    // that contains our global query params and fragment
    const navigationExtras: NavigationExtras = {
      queryParams: this.filterFormGroup.value,
      queryParamsHandling: 'merge'
    };

    // get current url
    const currentUrlPath = this.router.url.split('?')[0];

    this.router.navigate([currentUrlPath], navigationExtras);

  }

  resetForm(): void {
    this.initForm();
    this.filterQueriedResults();
  }

  setDefault() {
    this.filterParams.paramsMap.forEach((value: any, key) => {
      this.filterFormGroup.get(key).setValue(value);
    });
  }


  isEligibleForFollowUp(data, followupCount) {
    if (data !== "Yes" && followupCount < this.maxFollowUpallowed) {
      return false;
    }
    return true;
  }

  checkAll(ev) {
    if (ev.target.checked) {
      // TODO: Can be improved
      for (let i = 0; i < this.pagination.data.length; i++) {
        (<HTMLInputElement>document.getElementsByClassName('checkbox-all')[i]).checked = true;
        this.ids.push(this.pagination.data[i].id);
      }
      this.removeDuplicates();
    } else {
      for (let i = 0; i < this.pagination.data.length; i++) {
        (<HTMLInputElement>document.getElementsByClassName('checkbox-all')[i]).checked = false;
        this.ids = [];
      }
    }
  }

  /**
     * get values of the checkboxes and push them to an array
     * @param option
     * @param data
     */
  getValues(option, data) {
    if (data.target.checked) {
      this.ids.push(option);
      if ((this.pagination.data) && (this.ids.length === this.pagination.data.length)) {
        (<HTMLInputElement>document.getElementById('checkbox-all')).checked = true;
      }
    } else {
      const index = this.ids.indexOf(option);
      if (index !== -1) {
        this.ids.splice(index, 1);
        (<HTMLInputElement>document.getElementById('checkbox-all')).checked = false;
      }
    }
  }

  removeDuplicates() {

    this.ids = Array.from(new Set(this.ids));
  }

  sendMultipleFollowUpMail() {
    if (this.ids.length > 0) {
      swal({
        title: 'Are you sure?',
        text: 'You want to send followup email!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(() => {
        this.formService.sendMultipleFollowUpMail(this.ids).subscribe(
          response => {
            this.filterResults();

            if (response.sent.length > 0) {
              this.commonService.notifications.success('Email sent Successfully');
            } else {
              this.commonService.notifications.error('no email sent');
            }
            this.ids = [];
            (<HTMLInputElement>document.getElementById('checkbox-all')).checked = false;
          },
          error => {
            this.commonService.notifications.error(error);
          }
        );
      },
        function (dismiss) {
          swal(
            'Cancelled',
            '',
            'error'
          );
        });
    } else {
      swal('please select any ');
    }
  }

  sendFollowUpMail(id) {

    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then(() => {
      this.formService.sendFollowUpMail(id).subscribe(
        response => {
          this.filterResults();

          this.commonService.notifications.success('Email sent Successfully');
        },
        error => {
          this.commonService.notifications.error(error);
        }
      );
    },
      function (dismiss) {
        swal(
          'Cancelled',
          '',
          'error'
        );
      });

  }

  exportLogsExcel() {
    this.getData();
  }

  getData() {

    this.fetchingInProgress = true;
    this.formService.getDataForExcel(this.filterParams).subscribe(
      response => {
        this.downloadExcel(response, 'Invites Excel');
        this.fetchingInProgress = false;
        this.ngOnInit();

      },
      error => {
        this.commonService.notifications.error('Some Error Occurred')
        this.fetchingInProgress = false;
      });
  }

  toggleInviteStatus(inviteId: number): void {

    this.formService.toggleInviteStatus(inviteId).subscribe(

      response => {

        this.filterResults();

        if (response.success) {

          this.commonService.notifications.success('Success', 'status changed successfully');
        } else {

          this.commonService.notifications.error('error', 'some error occured');
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/form-invitees-list/form-invitees-list.component.ts